import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[noSpecialCharsTest]'
})
export class NoSpecialCharsTestDirective {
  // private regex: RegExp = new RegExp(/[$&+,:;=?@#|'<>.^*(){}\[\]%!\`\´\/°ª"~¨]/g);
  private regex: RegExp = new RegExp(/[^A-Za-záÁãÃâÂàÀéÉêÊíÍóÓõÕôÔúÚçÇ ]/g);

  private specialKeys = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event'])
  onkeypress(event: KeyboardEvent) {
    // TODO: Logs temporários para identificação de problemas na digitação dos campos de cadastro
    console.log('\n\n -------------- START keypress (noSpecialCharsTest) -------------- ');
    console.log('specialKeys: ', this.specialKeys);
    console.log('event.key: ', event.key, ' - event: ', event);
    console.log('this.specialKeys.indexOf(event.key): ', this.specialKeys.indexOf(event.key));
    if (this.specialKeys.indexOf(event.key) !== -1) {
      debugger
      console.log('return? ');
      return;
    }

    if (this.el && this.el.nativeElement) {
      const current: string = this.el.nativeElement.value;
      var next: string = event.key;
      if (current) {
        next = current.concat(event.key);
      }
      debugger
      console.log('\nnext: ', next);
      console.log('regex: ', this.regex);
      console.log('next && String(next).match(this.regex): ', (next && String(next).match(this.regex)));
      if (next && (String(next).match(this.regex))) {
        debugger
        console.log('event.preventDefault()');
        event.preventDefault();
      }
    }
    console.log('-------------- STOP keypress (noSpecialCharsTest) -------------- ');
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: KeyboardEvent) {
    if (this.el && this.el.nativeElement) {
      const current: string = this.el.nativeElement.value;
      var next: string = event.key;
      if (current) {
        next = current.concat(event.key);
      }
      debugger
      console.log('paste')
      console.log('next: ', next)
      console.log('regex: ', this.regex)
      console.log('preventDefault? ', next && String(next).match(this.regex) ? true : false, String(next).match(this.regex))

      if (next && String(next).match(this.regex)) {
        debugger
        event.preventDefault();
      }
    }
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: any) {
    debugger
    if (event && event.dataTransfer && event.dataTransfer.dropEffect) {
      event.dataTransfer.dropEffect = 'none';
      debugger
      return event.preventDefault();
    }
  }
}
